import { FC } from "react"
import { useTranslation } from "react-i18next"

import InlineControls from "./InlineControls"

interface IInlineControlsCancelSaveProps {
    onCancel?(): Promise<void> | void
    onSave?(): Promise<void> | void
    disabled?: boolean
}

const InlineControlsCancelSave: FC<IInlineControlsCancelSaveProps> = ({
    onCancel,
    onSave,
    disabled,
}) => {
    const { t } = useTranslation()

    return (
        <InlineControls
            items={[
                { onClick: onCancel, label: t("common.cancel"), disabled },
                { onClick: onSave, label: t("common.save"), disabled },
            ]}
        />
    )
}

export default InlineControlsCancelSave
